import styles from "./Modal.module.css";
import { validDomains } from "../../data/domains";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
function Modal({ modalContainerRef, showModal, setShowModal }) {
    const emailRef = useRef(null);
    const submitRef = useRef(null);
    const errorFldRef = useRef(null);
    const complianceErrorFldRef = useRef(null);
    const checkboxRef = useRef(null);

    const isProd = window.location.hostname === "youarehere.keelmind.com";

    const mainDomain = isProd
        ? "https://app.ca.geta-head.com"
        : "https://v2.dev.geta-head.com";

    const [programCode, setProgramCode] = useState(
        "program-matching-sp-ontario-universities"
    );

    const programRedirectUrl = mainDomain + "/app/gah";
    const invalidEmailFormat =
        "Invalid email format. Format must follow: mail@example.com";
    const invalidEmailForProgram =
        "Invalid email address. The email you provide must belong to a Canadian university";
    const networkError =
        "Unknown network error occurred. Please refresh your browser and try again.";
    const apiKey = isProd
        ? "MjXaFSz6S7Q6C1ORUfBIQdGN2xZsQJuA"
        : "NXn9VCmNLYjlkcv9StbDq9LnVm2dX7OL";
    const ouOrgCode = isProd ? "Vj5F" : "088R";

    const apiUrl = mainDomain + "/api/v1/cache/store"; //"https://reqbin.com/echo/post/json"

    const validDomainKeys = Object.keys(validDomains).map((dom) =>
        dom.replace(/https?:\/\/(www\.)?/, "").replace("/,ON", "")
    ); // remove prefix and /,ON

    const regexDomains = validDomainKeys.map((k) => {
        let regexPattern = `^[\\w.-]+@[\\w.-]*${k.replace(/\./g, "\\.")}$`;
        return new RegExp(regexPattern);
    });

    function checkValidEmailDomain(testString) {
        for (let regexTest of regexDomains) {
            //console.log(`testing ${testString} against pattern: ${regexTest}`);
            if (regexTest.test(testString)) {
                console.log("Found match with pattern: %s", regexTest.source);
                return true; //regexTest.source;
            }
        }
        return false;
    }

    function validateEmailFormat(userEmail) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(userEmail)) {
            return true;
        }
        //alert("You have entered an invalid email address!")
        return false;
    }

    function sendGAEvent(eventName, type, emailValue) {
        if (typeof window.gtag != "undefined") {
            window.gtag("event", eventName, {
                errorType: type,
                emailAddress: emailValue,
            });
        }
    }

    function redirectUrl(guid) {
        window.location.href = programRedirectUrl + "/#/programconnect/" + guid;
    }

    function setError(msg) {
        if (
            errorFldRef.current &&
            !errorFldRef.current.classList.contains(styles.error)
        ) {
            errorFldRef.current.innerHTML = msg;
            errorFldRef.current.classList.add(styles.error);
        }
    }

    // function removeError() {
    //     if (
    //         errorFldRef.current &&
    //         errorFldRef.current.classList.contains(styles.error)
    //     ) {
    //         errorFldRef.current.innerHTML = "";
    //         errorFldRef.current.classList.remove(styles.error);
    //     }
    // }

    async function fetchSendRequest(usrObj) {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                apikey: apiKey,
                //'Access-Control-Allow-Origin':'*',
            },
            body: `{"cache_payload": ${usrObj}}`,
        }).catch((err) => {
            window.alert(err);
        });
        if (response?.ok) {
            response.json().then((data) => {
                console.log("from fetch");
                console.log(data);
                redirectUrl(data);
            });
        } else {
            console.log(response?.statusText);
            setError(networkError);
        }
    }

    function handleSubmitButtonClick(ev) {
        if (!checkboxRef.current.checked) {
            complianceErrorFldRef.current.classList.add(styles.error);
            return;
        } else {
            complianceErrorFldRef.current.classList.remove(styles.error);
        }

        if (errorFldRef.current) {
            errorFldRef.current.classList.remove(styles.error);
            errorFldRef.current.innerHTML = "";
        }

        var emailField = emailRef.current;
        var emailValue =
            emailField != null ? emailField.value.toLowerCase() : "";

        if (validateEmailFormat(emailValue)) {
            var objCode = ouOrgCode;

            if (checkValidEmailDomain(emailValue)) {
                var userObj = JSON.stringify({
                    gah_role: "client",
                    gah_program_email: emailValue,
                    gah_program_org_code: objCode,
                    gah_program_code: programCode,
                });
                sendGAEvent("/ouValidEmail", "appRedirect", emailValue);
                fetchSendRequest(userObj);
            } else {
                sendGAEvent(
                    "/ouInvalidEmail",
                    "invalidEmailForProgram",
                    emailValue
                );
                setError(invalidEmailForProgram);
            }
        } else {
            sendGAEvent("/ouInvalidEmail", "invalidEmailFormat", emailValue);
            setError(invalidEmailFormat);
            //alert('invalid email address!  Please correct your email');
        }
        //alert(emailField.value);
    }

    useEffect(() => {
        console.log("now in the gah program connect load");

        if (typeof window.gahProgramCode != "undefined") {
            setProgramCode(window.gahProgramCode);
        }

        // if (submitBtn != null) {
        //     submitBtn.addEventListener("click", submitButtonClick, false);
        // }
    }, []);

    function handleEscape(event) {
        if (event.keyCode === 27) {
            event.preventDefault();
            setShowModal(false);
        }
    }

    return (
        <div
            className={[
                styles.modal_container,
                showModal ? styles.show : "",
            ].join(" ")}
            ref={modalContainerRef}
            onKeyDown={handleEscape}
        >
            <div className={styles.back_cover}></div>
            <div className={styles.modal}>
                <div
                    className={styles.close_button}
                    aria-label="Close sign up modal"
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                        setShowModal(false);
                    }}
                    onKeyDown={(event) => {
                        if (event.keyCode === 13) {
                            event.preventDefault();
                            setShowModal(false);
                        }
                    }}
                >
                    <img src="/x-icon.svg" alt="" />
                </div>
                <h2>Start your journey</h2>
                <p>
                    Connect to a mental health care provider today at no cost to
                    you. Your school email is used for signup purposes only. Any
                    sessions or notes taken on the platform{" "}
                    <strong>will not</strong> be shared with your school.
                </p>

                <label className={styles.modal_form_label}>
                    <input
                        className={styles.gah_email_fld}
                        type="text"
                        id={styles.gah_email_txt}
                        placeholder="Enter school email..."
                        ref={emailRef}
                    />
                    <strong className={styles.label_text}>School Email</strong>
                </label>
                <div
                    id={styles.gah_error_fld}
                    className={styles.gah_error_fld}
                    ref={errorFldRef}
                >
                    Invalid email address. The email you provide must belong to
                    a Canadian university
                </div>
                <label
                    className={[
                        styles.modal_form_label,
                        styles.horizontal_label,
                    ].join(" ")}
                >
                    <input
                        // onInput={handleCheckbox}
                        type="checkbox"
                        name=""
                        id={styles.gah_compliance_checkbox}
                        ref={checkboxRef}
                    />
                    <p>
                        I accept the{" "}
                        <a href="https://keelmind.com/terms-of-use">
                            terms of use
                        </a>{" "}
                        and{" "}
                        <a href="https://keelmind.com/privacy-policy">
                            privacy policy
                        </a>
                        .
                    </p>
                </label>
                <div
                    id={styles.gah_error_fld_compliance}
                    className={styles.gah_error_fld}
                    ref={complianceErrorFldRef}
                >
                    You must accept the terms of use and privacy policy.
                </div>
                <div className="javascript">
                    <button
                        href="/#"
                        ref={submitRef}
                        onClick={handleSubmitButtonClick}
                        id={styles.gah_submit_btn_2}
                        className={styles.cta_button}
                    >
                        Get started
                    </button>
                </div>

                <p className="p-tiny">
                    This program is funded by the Ministry of Colleges and
                    Universities and is intended for Ontario postsecondary
                    students only. If you are not an Ontario postsecondary
                    student and would like to learn more about this program or
                    Keel Mind, please{" "}
                    <a
                        href="https://www.keelmind.com/contact-us"
                        className="orange"
                    >
                        contact us
                    </a>
                </p>
            </div>
        </div>
    );
}

export default Modal;
